module.exports = __webpack_public_path__ + "static/media/pinaza_4.91072f5f.gif";